import { type WatchlistApproverConstructor } from '@webapp/modules/expense/entities/WatchlistApprover'
import { type WatchlistApproverOptionApiModel } from '../api-models/WatchlistApproverOptionApiModel'

export const mapWatchlistApproverOptionApiModel = (
  raw: WatchlistApproverOptionApiModel
): WatchlistApproverConstructor => ({
  id: raw.approver.id,
  firstName: raw.approver.firstName,
  lastName: raw.approver.lastName,
  approvalCount: raw.count,
})
